import factory from './factory'

export default {
  filterByRegion (state, value) {
    state.filtered = factory.filterByRegion(value).filtered

    state.appliedFilters = factory.appliedFilters
  }
}
